export default "__VITE_ASSET__CXdLwFwT__"